import { useEffect } from 'react';

// Must stay in sync with the ripple host list in index.css: only elements
// that clip their overflow, i.e. buttons — never product cards.
const HOSTS = '.btn, .chip, .seg button, .slot, .opt, .qr-btn';

/**
 * One delegated listener gives every tappable surface a material-style
 * ripple, without touching a single component.
 */
export default function useRipple() {
    useEffect(() => {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const onDown = (e) => {
            const host = e.target.closest && e.target.closest(HOSTS);
            if (!host || host.disabled) return;

            const rect = host.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            const span = document.createElement('span');
            span.className = 'ripple';
            span.style.width = span.style.height = `${size}px`;
            span.style.left = `${e.clientX - rect.left - size / 2}px`;
            span.style.top = `${e.clientY - rect.top - size / 2}px`;
            host.appendChild(span);
            span.addEventListener('animationend', () => span.remove(), { once: true });
            // safety net if the element unmounts mid-animation
            setTimeout(() => span.remove(), 900);
        };

        document.addEventListener('pointerdown', onDown, { passive: true });
        return () => document.removeEventListener('pointerdown', onDown);
    }, []);
}
